import type {
  BlockStateDefinition,
  ComponentType,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import { type CascaderComponentType } from '@unifyapps/defs/blocks/Cascader/types';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importCascaderComponent = () =>
  import(
    /* webpackChunkName: "cascader-block" */
    './Cascader'
  ) as Promise<{ default: ComponentType }>;

const Cascader = lazy(importCascaderComponent) as ComponentType;

class CascaderBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Cascader;
  }

  get type(): ComponentTypeUnionType {
    return 'Cascader';
  }

  get initialStateGetter() {
    return (block: BlockType<CascaderComponentType>) => ({
      id: block.id,
      selectedValue: null,
      selectedPath: null,
      ..._pick(block.component, ['content', 'appearance', 'componentType']),
    });
  }

  preload() {
    return {
      blockPreload: importCascaderComponent,
    };
  }
}

export default CascaderBlockStateDefinition;
